import React from 'react';
import Services from '../Components/Services';
import Twitte from '../Components/Twitte';
import WhyUs from '../Components/WhyUs';
import Contact from './Contact';

const Home = () => {
    return (
        <div>
            
            <Twitte />
            <Services />
            <WhyUs/>
            <Contact/>

        </div>
    );
};

export default Home;